import * as React from "react";
import type { SVGProps } from "react";
const SvgRenewalOptions = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={20}
    fill="none"
    viewBox="0 0 21 20" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7 2.5V5M14.5 2.5V5"
    />
    <rect
      width={15}
      height={13.75}
      x={3.25}
      y={3.75}
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      rx={3}
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.917 9.585h5M9.917 12.917h5M6.583 9.585h.834M6.583 12.917h.834"
    />
  </svg>
);
export default SvgRenewalOptions;
